import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvItemComponent, MarvMessageComponent } from '@marv/components';
import { PermanentOperationItem, OperationLogo, OperationLogoComponent, PermanentAgentItem, PermanentAgentItemComponent } from '@app/components';
import { PermanentAgentService } from '@app/services';

@Component({
    selector: 'app-permanent-operation-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => MarvItemComponent), forwardRef(() => MarvMessageComponent), 
        forwardRef(() => OperationLogoComponent), forwardRef(() => PermanentAgentItemComponent)
    ]
})
export class PermanentOperationItemComponent  implements OnInit {

    @Input({alias : 'permanentOperation', required : true}) permanentOperation: PermanentOperationItem;

    permanentsAgentsItems: Array<PermanentAgentItem> = [];
    operationLogo: OperationLogo;
    isOpened: boolean = false;

    constructor(
        private permanentAgentService: PermanentAgentService
    ) { }

    async ngOnInit() {
        let permanentsAgentsItems: Array<PermanentAgentItem> = [];
        this.operationLogo = new OperationLogo(this.permanentOperation.name, this.permanentOperation.logo);
        let permanentsAgents = await this.permanentAgentService.loadPermanentsAgents(this.permanentOperation.id);
        if(permanentsAgents){
             for(let a of permanentsAgents){
                 permanentsAgentsItems.push(PermanentAgentItem.FromPermanentAgent(a));
             }
        }
        this.permanentsAgentsItems = permanentsAgentsItems;
    }

    togglePeople(){
        this.isOpened = !this.isOpened;
    }
}
